import React from 'react';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import { Controls, validators } from 'shared/helper/form';
var Text = Controls.Text;
var notEmpty = validators.notEmpty;
var OrderPanelHeader = function OrderPanelHeader(_ref) {
  var editingOrderDetails = _ref.editingOrderDetails,
    order = _ref.order,
    awaitingPayment = _ref.awaitingPayment,
    _ref$pathname = _ref.pathname,
    pathname = _ref$pathname === void 0 ? null : _ref$pathname;
  return /*#__PURE__*/React.createElement("div", {
    className: "row order-panel-header\n            ".concat(order.status.toLowerCase().replace(/ /g, ''), "\n            ").concat(awaitingPayment ? 'awaiting-payment' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 order-title-wrapper"
  }, /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: "/researcher/index/details/".concat(order.externalId),
      state: {
        previousPath: pathname
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "order-id me-1"
  }, order.externalId, ":"), /*#__PURE__*/React.createElement("span", {
    className: "order-title"
  }, !editingOrderDetails ? order.title : /*#__PURE__*/React.createElement(Text, {
    name: "title",
    validators: {
      notEmpty: notEmpty
    },
    message: {
      notEmpty: 'You must specify a title '
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 order-service-status text-start text-md-right"
  }, /*#__PURE__*/React.createElement(T, {
    source: awaitingPayment ? 'Awaiting Payment' : "order-status-".concat(order.status.toLowerCase().replace(/ /g, ''))
  })));
};
export default OrderPanelHeader;